import { Fragment } from "react";
import { GrChip, GrStack, GrTypography, palette } from "@jnpmedi/grebob";
import { resolveDocumentSignerStatusChip } from "@newPages/eConsent/eConsentStatusPage/types";
import { langHelper, MvnMessage } from "@newLibs/utils";
import { multiLineEllipsis } from "@assets/styles/layout";
import { DOCS_DOCUMENT_SIGN_LANG } from "@maven-msg/lang/docs";
import { DocumentSignerStatus, DocumentSignResource, DocumentSignStatus } from "@maven-rest/docs/DocumentSign.dto";
import { ReadableDocumentSignerStatus } from "@maven-rest/docs/DocumentSigner.conv";

interface CommonSignerSigneeSectionProps {
  documentSignResource: DocumentSignResource;
}

export function CommonSignerSigneeSection({ documentSignResource }: CommonSignerSigneeSectionProps) {
  const loLang = langHelper.getLang();

  const doumentSignStatus = documentSignResource.status;

  const isDocumentSignTerminated = [
    DocumentSignStatus.Expired,
    DocumentSignStatus.Expiring,
    DocumentSignStatus.ExpiringFailed,
    DocumentSignStatus.Cancel,
    DocumentSignStatus.Canceling,
    DocumentSignStatus.CancelingFailed,
    DocumentSignStatus.Canceled,
    DocumentSignStatus.Decline,
    DocumentSignStatus.Declined,
    DocumentSignStatus.Declining,
    DocumentSignStatus.DecliningFailed,
  ].includes(doumentSignStatus);

  return (
    <GrStack
      style={{ padding: "8px 16px 0px", backgroundColor: palette["white"], width: "100%", borderRadius: "6px" }}
      flexDirection="column"
      gap={12}
    >
      <GrTypography type="Content.Subtitle02" color="grey080">
        {MvnMessage(DOCS_DOCUMENT_SIGN_LANG.DOCUMENT_SIGN_EMAIL_SIGNERS)}
      </GrTypography>

      <GrStack flexDirection="column" gap="8px">
        {documentSignResource.signers.map((signer) => {
          const isNotSigned =
            isDocumentSignTerminated && ![DocumentSignerStatus.Signed, DocumentSignerStatus.Declined].includes(signer.status);

          return (
            <Fragment key={String(signer.id)}>
              <GrStack justifyContent="space-between" alignItems="center">
                <GrStack gap={12} alignItems="center" style={{ flex: 1 }}>
                  <GrStack flexDirection="column" gap={2}>
                    <GrTypography type="Content.Subtitle03" color="grey080" css={multiLineEllipsis(1)}>
                      {signer.name}
                    </GrTypography>
                    <GrTypography type="Content.Body03" color="grey050">
                      {signer.email}
                    </GrTypography>
                  </GrStack>
                </GrStack>
                <GrStack alignItems="center" gap="8px">
                  <GrChip
                    size="medium"
                    color={isNotSigned ? "grey" : resolveDocumentSignerStatusChip(signer.status)}
                    variant="outlined-soft"
                    shape="circle"
                    label={
                      isNotSigned
                        ? MvnMessage(DOCS_DOCUMENT_SIGN_LANG.DOCUMENT_SIGN_NOT_SIGNED)
                        : ReadableDocumentSignerStatus(signer.status, loLang)
                    }
                  />
                </GrStack>
              </GrStack>
            </Fragment>
          );
        })}
      </GrStack>
    </GrStack>
  );
}
